import ajax from "@/customApi";
const qs = require("qs");
import config from "../../../../config";
import { eventBus } from "@/main";
const { path, messages } = config;

const service = {
  getAll,
  updatePlan,
  getById,
  updateStatus,
  planStoreMapping,
  getModuleMasterList,
  getPlanModulePermissionById,
  planModuleMapping,
  getCategoryOptions,
};

async function getAll(params = {}) {
  let { siteId } = params;
  try {
    const  { statusCode, data } = await ajax.get(`${path.getFairstonePlansList}/${siteId}`, {
        name: "fairstonePlans"
    });
    return data;
  } catch (error) {
    if (error.response.status === 401) {
      eventBus.$emit("apiError", messages.unauthorizedUser);
      return [];
    } else eventBus.$emit("apiError", error.message);
    ajax.post(path.exception, {
      name: "fairstonePlans",
      body: {
        id: 0,
        userId: userId,
        exceptionMessage: error.response.data,
        controllerName: "Listing.vue",
        actionName: "getAll",
        exceptionStackTrace: `API : ${path.getFairstonePlansList}`,
        moduleName: "Listing",
        isApi: 0,
      },
    });
    return [];
  }
}

async function getById(params) {
  try {
    const  { statusCode, data } = await ajax.get(`${path.getFairstonePlanById}/${params.siteId}`, {
      name: "fairstonePlan edit",
      params: { productId: params.productId },
      paramsSerializer: function (params) {
        return qs.stringify(params, { arrayFormat: "comma" });
      },
    });
    return data;
  } catch (error) {
    if (error.response.status === 401) {
      eventBus.$emit("apiError", messages.unauthorizedUser);
      return {};
    } else if(error.response.status === 500) {
       throw new Error("Server error: 500 Internal Server Error");
    } else eventBus.$emit("apiError", error.message);
    ajax.post(path.exception, {
      name: "fairstonePlan edit",
      body: {
        id: 0,
        userId: params.userId,
        exceptionMessage: error.response.data,
        controllerName: "Form.vue",
        actionName: "getById",
        exceptionStackTrace: `API : ${path.getFairstonePlanById}`,
        moduleName: "Form",
        isApi: 0,
      },
    });
    return {};
  }
}


async function getCategoryOptions() {
  try {
    const  { data } = await ajax.get(`${path.getCategoryNamesList}`, {
      name: "fairstonePlan edit"
    });
    return data;
  } catch (error) {
    if (error.response.status === 401) {
      eventBus.$emit("apiError", messages.unauthorizedUser);
      return [];
    } else eventBus.$emit("apiError", error.message);
    return [];
  }
}

async function updatePlan(plan) {
  try {
    var { data } = await ajax.post(path.saveFairstonePlanById, {
      name: "fairstonePlans",
      body: plan,
    });
    return { status: 1 };
  } catch (error) {
    if (error.response?.status === 401) {
      eventBus.$emit("apiError", messages.unauthorizedUser);
      return { status: 0, type: "other", error: error };
    } else if(error.response.status === 500) {
      return {
        status: 0,
        type: "server",
        error: error.response?.data || "Server error: 500 Internal Server Error"
      };
    } else if(error.response.status === 400) {
      return { status: 0, type: "other", error: error.response.errors};
    } else {
      const message = error.response?.data?.message || error.message || "Unknown error occurred";
      eventBus.$emit("apiError", message);
      return { status: 0, type: "other", error: message };
    }
  }
}

async function updateStatus(body) {
  try {
    const { data } = await ajax.post(path.setEnabledDisabled, {
      name: "SiteFairstonePlansEnabledDisabled",
      body: { ...body }
    });
    return data;
  } catch (error) {
    if (error.response.status === 401) {
      eventBus.$emit("apiError", messages.unauthorizedUser);
      return 0;
    } else if(error.response.status === 500) {
      return {"status": error.response.status, "error": "Server error: 500 Internal Server Error"};
    } else if (error.response.status === 400) {
      let errorMessages = "Validation error";
      if (error.response.data.errors && error.response.data.errors.length > 0) {
        errorMessages = error.response.data.errors.map(err => `${err.ProductId} - ${err.Message}`).join(' ');
      }
      return {"status": error.response.status, "error": errorMessages};
    } else {
      eventBus.$emit("apiError", error.message);
      return 0;
    }
  }
}

async function planStoreMapping(params) {
  let { loginId } = params;

  try {
    const { data } = await ajax.post(path.planStoreMapping, {
      body: params,
    });
    return data;
  } catch (error) {
    if (error.response.status === 401) {
      eventBus.$emit("apiError", messages.unauthorizedUser);
      return 0;
    } else eventBus.$emit("apiError", error.message);
    ajax.post(path.exception, {
      name: "planStoreMapping",
      body: {
        id: 0,
        userId: loginId,
        exceptionMessage: error.response.data,
        controllerName: "List.vue",
        actionName: "planStoreMapping",
        exceptionStackTrace: `API : ${path.planStoreMapping}`,
        moduleName: "List",
        isApi: 0,
      },
    });
    return 0;
  }
}

async function getModuleMasterList(params) {
  let { loginId } = params;

  try {
    const { data } = await ajax.get(path.getFairstonePlanModuleMasterList, {
      name: "module master list",
    });
    return data;
  } catch (error) {
    if (error.response.status === 401) {
      eventBus.$emit("apiError", messages.unauthorizedUser);
      return [];
    } else eventBus.$emit("apiError", error.message);
    ajax.post(path.exception, {
      name: "module master list",
      body: {
        id: 0,
        userId: loginId,
        exceptionMessage: error.response.data,
        controllerName: "Permission.vue",
        actionName: "getModuleMasterList",
        exceptionStackTrace: `API : ${path.getFairstonePlanModuleMasterList}`,
        moduleName: "Permission",
        isApi: 0,
      },
    });
    return [];
  }
}

async function getPlanModulePermissionById(params) {
  let { loginId } = params;
  try {
    const { data } = await ajax.get(path.getFairstonePlanModulePermissionById, {
      params: params,
      paramsSerializer: function (params) {
        return qs.stringify(params, { arrayFormat: "comma" });
      },
    });
    return data;
  } catch (error) {
    if (error.response.status === 401) {
      eventBus.$emit("apiError", messages.unauthorizedUser);
    }
    eventBus.$emit("apiError", error.message);
    ajax.post(path.exception, {
      name: "getPlanModulePermissionById",
      body: {
        id: 0,
        userId: loginId,
        exceptionMessage: error.response.data,
        controllerName: "Permission.vue",
        actionName: "getPlanModulePermissionById",
        exceptionStackTrace: `API : ${path.getFairstonePlanModulePermissionById}`,
        moduleName: "Permission",
        isApi: 0,
      },
    });
    return [];
  }
}

async function planModuleMapping(params) {
  let { loginUserId } = params;

  try {
    await ajax.post(path.planModuleMapping, {
      body: params,
    });
    return 1;
  } catch (error) {
    if (error.response.status === 401) {
      eventBus.$emit("apiError", messages.unauthorizedUser);
      return 0;
    } else eventBus.$emit("apiError", error.message);
    ajax.post(path.exception, {
      name: "planModuleMapping",
      body: {
        id: 0,
        userId: loginUserId,
        exceptionMessage: error.response.data,
        controllerName: "Permission.vue",
        actionName: "planModuleMapping",
        exceptionStackTrace: `API : ${path.planModuleMapping}`,
        moduleName: "Permission",
        isApi: 0,
      },
    });
    return 0;
  }
}

export default service;
